import React, { useEffect, useState, useContext } from 'react'
import { useQuery } from '../../Routing/utils'
import { LeagueContext } from '../../Context'
import { AutocompleteContainer } from '../../Components/Search'
import { PageHeader } from '../../Components/Headers'
import { PageContainerMain, Box, BottomAppCallout } from '../../Components/Layout'
import { ScheduleHeader } from '../Schedule/ScheduleHeader'
import { WeekBox, WeekHeader } from './components/weekBox'
import { getBanner, getWeekList } from '../../Utils'
import { mapEventWeeks } from '../../Utils/Events/eventHelpers'
import type { Banner, EventGQL } from '../../Api'
import { Loading } from '../Loading'
import { WeekSlider } from '../../Components/WeekSlider/WeekSlider'
import { SponsorTopBanner } from '../../Components/Layout/sponsorBanners'
import { createScoresDynamicLink } from '../../Utils/DynamicLinks/dynamicLinkHelpers'
import { ScheduleCon, SliderCon, SliderVert, WeekendCon } from '../Schedule/schedStyles'
import { AdUnit } from '../../Components/Ads/AdUnit'

const Scores: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { banners, events, eventsLoading } = useContext(LeagueContext)!
  const [wkEvents, setWkEvents] = useState<EventGQL[]>([])
  const [weeks, setWeeks] = useState<string[]>([])
  const [selectedWeek, setSelectedWeek] = useState<number>(1)
  const [banner, setBanner] = useState<Banner>(null)

  let queryParams = useQuery()
  const weekQuery = queryParams && queryParams.get('week')
  const weekQueryNum = weekQuery ? parseInt(weekQuery) : null

  useEffect(() => {
    if (banners.length > 0) {
      const b = getBanner(banners, 'scores')
      if (!b) return
      setBanner(b)
    }
  }, [banners])

  useEffect(() => {
    if (events.length > 0) {
      const weekList = getWeekList(events)
      setWeeks(weekList)
      //Week parameter in url
      if (weekQueryNum && weekQueryNum <= weekList.length) {
        setSelectedWeek(weekQueryNum)
        const wkEvs = mapEventWeeks({
          week: selectedWeek.toString(),
          events: events,
        })
        setWkEvents(wkEvs)
        return
      }
      const weekRes = events.find((ev) => ev.eventStatus < 2)
      if (!weekRes) {
        //no upcoming games
        const evs = [...events]
        const lastGame = evs.pop()
        if (!lastGame) return
        let lastWk = parseInt(lastGame.week)
        setSelectedWeek(lastWk)

        const wkEvs = mapEventWeeks({
          week: selectedWeek.toString(),
          events: events,
        })
        setWkEvents(wkEvs)
        return
      }
      const wk = weekRes.week
      const wkNum = parseInt(wk)
      setSelectedWeek(wkNum)

      const wkEvs = mapEventWeeks({
        week: selectedWeek.toString(),
        events: events,
      })
      setWkEvents(wkEvs)
      return
    } else {
      return
    }
  }, [events])

  useEffect(() => {
    if (events.length > 0) {
      const wkEvs = mapEventWeeks({
        week: selectedWeek.toString(),
        events: events,
      })
      setWkEvents(wkEvs)
    }
  }, [selectedWeek])

  const handleWeekChange = (wk: string) => {
    const wkNum = parseInt(wk)
    setSelectedWeek(wkNum)
  }

  return (
    <>
      <PageContainerMain sidePadding={0} fullScreen>
        {banner && !banner.sponsor && (
          <PageHeader banner={banner} img={banner.topUrl} link={banner.topLink} />
        )}
        {banner && banner.sponsor && (
          <SponsorTopBanner img={banner.topUrl} link={banner.topLink} banner={banner} />
        )}
        <AutocompleteContainer />
        <AdUnit bannerType="bannerMain" aria-label="Scores page ad" />
        <ScheduleHeader
          showListView={false}
          page={'Scores'}
          team={'All'}
          showHeaderItems={false}
        />
        {eventsLoading ? (
          <Box>
            <Loading />
            <AdUnit bannerType="bannerMain" aria-label="Scores page ad loading" />
          </Box>
        ) : (
          <>
            {events.length > 0 && (
              <>
                <ScheduleCon>
                  <SliderVert>
                    <WeekSlider
                      weeks={weeks}
                      eventsList={events}
                      currentWeek={selectedWeek.toString()}
                      handleWeekChange={handleWeekChange}
                      page="Scores"
                      idx={(selectedWeek - 1).toString()}
                      direction={'vertical'}
                    />
                  </SliderVert>
                  <>
                    <SliderCon>
                      <WeekSlider
                        weeks={weeks}
                        eventsList={events}
                        currentWeek={selectedWeek.toString()}
                        handleWeekChange={handleWeekChange}
                        page="Scores"
                        idx={(selectedWeek - 1).toString()}
                      />
                    </SliderCon>
                    <WeekendCon>
                      <WeekHeader week={selectedWeek.toString()} events={wkEvents} />
                      <WeekBox week={selectedWeek.toString()} events={wkEvents} />
                    </WeekendCon>
                  </>
                </ScheduleCon>
                <AdUnit bannerType="bannerSecond" aria-label="Scores page ad second" />
              </>
            )}
          </>
        )}
      </PageContainerMain>
      <BottomAppCallout
        appLink={createScoresDynamicLink(true)}
        location="scores"
        text="Easily track scores in the PLL App"
      />
    </>
  )
}

export default Scores
